// extracted by mini-css-extract-plugin
export var redoItem = "_jf-1";
export var redoTrigger = "_jf-0";